import { render, staticRenderFns } from "./duplicateLogDetail.vue?vue&type=template&id=0ae00a06&scoped=true"
import script from "./duplicateLogDetail.vue?vue&type=script&lang=js"
export * from "./duplicateLogDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae00a06",
  null
  
)

export default component.exports